'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var page = {
        width: theme.gutter * 3 + 'px',
        height: theme.gutter * 3 + 'px',
        textAlign: 'center',
        color: theme.idleColor,
        background: theme.idleBackground,
        display: 'inline-block',
        fontSize: theme.fontSize,
        lineHeight: theme.gutter * 3 + 'px',
        verticalAlign: 'middle',
        userSelect: 'none',
        cursor: 'pointer',
        position: 'relative',
        zIndex: 2,
        transition: 'color ' + theme.transitionDuration + ' ' + theme.transitionFunction
    };

    var pageSelected = Object.assign({}, page, {
        background: theme.selectedBackground,
        color: theme.selectedColor
    });

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            position: 'relative',
            display: 'inline-block',
            font: theme.tsNormal + '/' + theme.tlNormal + ' "' + theme.fontFamily + '"',
            color: theme.color,
            whiteSpace: 'nowrap',
            width: theme.width,
            minWidth: theme.minWidth
        },
        pageWrapperSelected: {
            transition: 'background ' + theme.transitionDuration + ' ' + theme.transitionFunction + ', color ' + theme.transitionDuration + ' ' + theme.transitionFunction,
            borderRadius: theme.borderRadius,
            height: '100%',

            '&:hover': {
                background: theme.selectedHoverBackground,
                color: theme.selectedHoverColor
            }
        },
        pageWrapper: {
            height: '100%',
            borderRadius: theme.borderRadius
        },
        page: Object.assign({}, page, {

            '&:hover': {
                color: theme.hoverColor,
                background: theme.hoverBackground
            }
        }),
        pageSelected: pageSelected,
        pageSelectedStart: Object.assign({}, pageSelected, {
            borderTopLeftRadius: theme.borderRadius,
            borderBottomLeftRadius: theme.borderRadius
        }),
        pageSelectedEnd: Object.assign({}, pageSelected, {
            borderTopRightRadius: theme.borderRadius,
            borderBottomRightRadius: theme.borderRadius
        }),
        pageSelectedSingle: Object.assign({}, pageSelected, {
            borderRadius: theme.borderRadius
        }),
        incrementButton: {
            marginLeft: theme.gutter * 3 + 'px',
            verticalAlign: 'middle'
        },
        increment: {
            width: theme.gutter * 3 + 'px',
            height: theme.gutter * 3 + 'px',
            backgroundImage: 'url(' + theme.incrementAppearance + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        },
        decrement: {
            width: theme.gutter * 3 + 'px',
            height: theme.gutter * 3 + 'px',
            backgroundImage: 'url(' + theme.decrementAppearance + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        },
        decrementButton: {
            marginRight: theme.gutter * 3 + 'px',
            verticalAlign: 'middle'
        },
        separator: Object.assign({}, page, {
            cursor: 'default'
        }),
        separatorSelected: Object.assign({}, pageSelected, {
            cursor: 'default'
        })
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        pageWrapper: (0, _aphroditeJss.css)(styleList.pageWrapper),
        pageWrapperSelected: (0, _aphroditeJss.css)(styleList.pageWrapperSelected),
        pageSelectedStart: (0, _aphroditeJss.css)(styleList.pageSelectedStart),
        page: (0, _aphroditeJss.css)(styleList.page),
        pageSelectedEnd: (0, _aphroditeJss.css)(styleList.pageSelectedEnd),
        pageSelected: (0, _aphroditeJss.css)(styleList.pageSelected),
        pageSelectedSingle: (0, _aphroditeJss.css)(styleList.pageSelectedSingle),
        increment: (0, _aphroditeJss.css)(styleList.increment),
        decrement: (0, _aphroditeJss.css)(styleList.decrement),
        decrementButton: (0, _aphroditeJss.css)(styleList.decrementButton),
        incrementButton: (0, _aphroditeJss.css)(styleList.incrementButton),
        separator: (0, _aphroditeJss.css)(styleList.separator),
        separatorSelected: (0, _aphroditeJss.css)(styleList.separatorSelected)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _arrow_right = require('../img/arrow_right.svg');

var _arrow_right2 = _interopRequireDefault(_arrow_right);

var _arrow_left = require('../img/arrow_left.svg');

var _arrow_left2 = _interopRequireDefault(_arrow_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    var primary = (0, _color2.default)(theme.elAccent),
        hoverColor = void 0;

    hoverColor = primary.rotate(2);
    hoverColor = (0, _color2.default)(hoverColor).saturate(0.3);
    hoverColor = (0, _color2.default)(hoverColor).darken(0.2);
    hoverColor = hoverColor.rgb().string();

    return {
        fontSize: theme.tsXSmall,
        borderRadius: '50%',
        incrementAppearance: _arrow_right2.default,
        decrementAppearance: _arrow_left2.default,

        idleColor: theme.tInactive,
        idleBackground: 'transparent',

        hoverBackground: 'transparent',
        hoverColor: theme.tFilled,

        selectedBackground: theme.elAccent,
        selectedColor: theme.tInversion,

        selectedHoverBackground: hoverColor,
        selectedHoverColor: theme.tInversion,
        width: 'auto',
        minWidth: 'auto'
    };
};